import type {
  CommunicationDetails,
  DocumentCommunicationDetails,
  StructuredCommunicationDetails,
} from '@izimi/api';

import BaseCommunicationDetailsEntity from './BaseCommunicationDetailsEntity';
import CommunicationDetailsEntity from './CommunicationDetailsEntity';
import StructuredCommunicationDetailsEntity from './StructuredCommunicationDetailsEntity';

/**
 *
 * Currently defaults to false to avoid breaking legacy usage of communications module.
 *
 * TODO: Remove this default and make it required in a future release.
 */
const isStructuredCommunicationDetails = (communicationDetails: CommunicationDetails) =>
  communicationDetails.type?.toLowerCase().includes('structured') ?? false;

/**
 * @deprecated Entity mapping is being removed. Consume the raw `BoxCommunicationDetails` returned
 * by the new `createCommunicationsModule` hooks instead of mapping to entities.
 */
export const mapCommunicationToEntity = (
  communicationDetails: CommunicationDetails,
  collection?: string,
) =>
  isStructuredCommunicationDetails(communicationDetails)
    ? new StructuredCommunicationDetailsEntity(
        communicationDetails as StructuredCommunicationDetails,
        collection,
      )
    : new CommunicationDetailsEntity(
        communicationDetails as DocumentCommunicationDetails,
        collection,
      );

/**
 * @deprecated Entity mapping is being removed. Consume the raw `BoxCommunicationDetails` returned
 * by the new `createCommunicationsModule` hooks instead of mapping to entities.
 */
export const mapCommunicationsToEntities = (communications: CommunicationDetails[] = []) =>
  communications.map((communication) => mapCommunicationToEntity(communication));

/**
 * @deprecated Use `isDocumentCommunication` / `isStructuredCommunication` from
 * `communications/helpers.ts` on the raw `BoxCommunicationDetails` instead.
 */
export const isCommunicationDetailsEntity = (
  item: unknown,
): item is BaseCommunicationDetailsEntity => item instanceof BaseCommunicationDetailsEntity;

/**
 * @deprecated Use `isDocumentCommunication` from `communications/helpers.ts` on the raw
 * `BoxCommunicationDetails` instead.
 */
export const isCommunication = (item: unknown): item is CommunicationDetailsEntity =>
  item instanceof CommunicationDetailsEntity;

/**
 * @deprecated Use `isStructuredCommunication` from `communications/helpers.ts` on the raw
 * `BoxCommunicationDetails` instead.
 */
export const isStructuredCommunicationEntity = (
  item: unknown,
): item is StructuredCommunicationDetailsEntity =>
  item instanceof StructuredCommunicationDetailsEntity;
